<template>
  <main-layout>
    <template slot="header-title">Advices</template>

    <template slot="header-actions" v-if="isAdmin">
      <common-button
        @click="openCreation = true">Create KPI</common-button>
    </template>

    <template slot="main">
      <div class="container mx-auto">
        <kpi v-if="kpis.length > 0" class="kpi-list" v-for="kpi in kpis" :key="kpi.id" :id="kpi.id"></kpi>
        <empty v-if="kpis.length === 0" title="Aucune KPI" :message="isAdmin ? 'Pour créer une KPI, rien de plus simple, il suffit de cliquer sur le lien suivant :' : ''">
          <a v-if="isAdmin" @click="openCreation = true">Créer une KPI</a>
        </empty>
        <kpi-form v-if="openCreation" :open="openCreation" @close="close"></kpi-form>
      </div>
    </template>
  </main-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import kpi from '@/components/advice/kpi.vue'
import kpiForm from '@/components/advice/kpi-form.vue'
import empty from '@/components/box-entity-empty.vue'

export default {
  name: 'KPIList',

  components: { kpi, kpiForm, empty },

  data () {
    return {
      openCreation: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('kpis', {
      kpis: 'kpis'
    }),

    ...mapGetters('user', {
      isAdmin: 'isAdmin'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('kpis', ['loadKpis']),
    ...mapActions('advices', ['loadAdvices']),

    init () {
      if (this.site) {
        this.loadKpis()
        this.loadAdvices()
      }
    },

    close () {
      this.openCreation = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Advice/KPIList.vue